<template>
    <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
      <v-dialog v-model="permitted_dialog" max-width="400px">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
              <p>{{message}}</p>
              <v-progress-circular
                :size="70"
                :width="2"
                :value="100"
                color="error"
                class="mb-4 mr-4"
              >
                <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
              </v-progress-circular>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container v-else v-show="permitted != null" class="pt-0" fluid>
      <v-snackbar
        :value="showMessage()"
        multi-line
        color="#686868"
        top
        
      >
        {{message}}
      </v-snackbar>
      <v-card flat>
      <v-toolbar dense flat color="#2A353D">
        <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Property Prices</v-toolbar-title>
        <v-spacer/>
        <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      </v-card>

      <v-data-table
        disable-pagination
        hide-default-footer
        :height="520"
        fixed-header
        :headers="headers"
        :show-select="!confirmedPropertyValues"
        item-key="ValuationId"
        v-model="selected"
        :items="confirmedPropertyValues ? properties : allPropertyValues.filter(b => b.CheckerID === 0)"
        :search="search"
        sort-by="PropertyID"
        sort-desc
        class="elevation-12 mt-2"
        @current-items="getFiltered"
      >
    
        <template v-slot:top >
          <v-dialog persistent v-model="rejectionDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>
    
              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>
    
              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    ok
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog persistent v-model="newDialog" max-width="500px">
            <v-card v-if="currentProperty">
              <v-toolbar dense flat color="#2A353D">
                <v-toolbar-title class="white--text subtitle-1 font-weight-normal">New prices for {{ properties.filter(p => p.PropertyID == currentProperty.PropertyID).map(p => p.PropertyName)[0] }}</v-toolbar-title>
              </v-toolbar>
    
              <v-card-text class="mt-6">
                <v-text-field
                  v-model="currentProperty.MarketValue"
                  dense filled
                  color="#2A353D"
                  label="Market Value"
                  required type="number"
                  placeholder="----"
                  :rules="TextFieldRules"
                ></v-text-field>

                <v-text-field
                  v-model="currentProperty.UnitPrice"
                  dense filled
                  color="#2A353D"
                  label="Unit Price"
                  required type="number"
                  placeholder="----"
                  :rules="TextFieldRules"
                ></v-text-field>
              </v-card-text>
    
              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="newDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="createNew();">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    submit
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog persistent v-model="historyDialog" max-width="800px">
            <v-card v-if="currentProperty">
              <v-toolbar dense flat color="#2A353D">
                <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Price history for {{ properties.filter(p => p.PropertyID == currentProperty.PropertyID).map(p => p.PropertyName)[0] }}</v-toolbar-title>
              </v-toolbar>
    
              <v-card-text>
                <v-data-table
                  disable-pagination
                  hide-default-footer
                  :height="500"
                  fixed-header
                  :headers="history_headers"
                  item-key="ValuationId"
                  v-model="selected"
                  :items="priceHistory"
                  :search="search"
                  sort-by="PropertyID"
                  sort-desc
                  class="elevation-0 mt-2"
                  @current-items="getFiltered"
                >
                </v-data-table>
              </v-card-text>
    
              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="historyDialog = false">close</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        
          <v-container row>
            <!-- <v-text-field
              class="ml-3"
              hide-details
              outlined
              placeholder="search..."
              v-model="search"
              append-icon="mdi-magnify"
              dense
            ></v-text-field>
    
            <v-spacer></v-spacer> -->
    
            <!-- <v-btn @click="createNew()" v-if="confirmedPropertyValues" :disabled="showCreateBtn == false || loading == true" small outlined color="#2A353D" class="ml-2" v-on="on">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              submit
            </v-btn> -->
            <v-btn @click="updateStatus()" v-if="!confirmedPropertyValues" :disabled="showConfirmBtn == false || selected < 1" outlined small color="#2A353D" class="ml-2" v-on="on">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
            </v-btn>
            <v-btn @click="rejectionDialog = true" v-if="!confirmedPropertyValues" :disabled="showConfirmBtn == false || selected < 1" outlined small color="#2A353D" class="ml-2" v-on="on">
              reject<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="!confirmedPropertyValues" @click="confirmedPropertyValues = true" outlined small color="#2A353D" class="ml-2" v-on="on">
              NEW PRICES<v-icon class="ml-1">mdi-playlist-check</v-icon>
            </v-btn>
          </v-container>
        </template>

        <template v-slot:item.PropertyID="{item}">
          {{ properties.filter(p => p.PropertyID == item.PropertyID).map(p => p.PropertyName)[0] }}
        </template>
        
        <template v-slot:item.ValuationDate="{ item }">
          {{ item.ValuationDate | moment("DD/MM/YYYY") }}
        </template>   

        <template v-slot:item.MarketValue="{ item }">
          {{ Number(item.MarketValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
        </template>
      
        <template v-slot:item.UnitPrice="{ item }">
          {{ Number(item.UnitPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
          <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
          <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
        </template>
    
        <template v-slot:item.actions="{ item }">
          <v-btn
            v-show="confirmedPropertyValues"
            small outlined v-if="showCreateBtn == true"
            color="#2A353D" class="mr-3"
            @click="setActiveProperty(item); newDialog = true"
          >
            <span>new</span>
          </v-btn>
          <v-btn
            small outlined
            @click="setActiveProperty(item); getPriceHistory(item)"
            color="#2A353D" class="mr-3"
          >
            <span v-show="loading && !newDialog && currentProperty == item" class="spinner-border spinner-border-sm mr-1"></span>
            <span>history</span>
          </v-btn>
        </template>

      </v-data-table>
    </v-container>
    </template>
    
    <script>
    import {mapGetters, mapActions} from "vuex";
    import UserService from '../services/user.service';
    import AdministrationService from "../services/administration.service";
    import jsPDF from 'jspdf';
    import 'jspdf-autotable'
    
    export default {
      data () {
        return {
          confirmedPropertyValues: true,
          permitted: null,
          permitted_dialog: true,
          loading: false,
          edit: false,
          create: false,
          view: false,
          rejectionDialog: false,
          newDialog: false,
          historyDialog: false,
          RejectionStatus: 0,
          message: '',
          search: '',
          valid: true,
          currentProperty: null,
          currentIndex: -1,
          CurrentDataset: [],
          headers: [
            {
              text: 'Name',
              align: 'start',
              sortable: true,
              value: 'PropertyID'
            },
            { text: 'Valuation Date', value: 'ValuationDate', sortable: false },
            { text: 'Market Value', value: 'MarketValue', sortable: false, align: 'end' },
            { text: 'Unit Price', value: 'UnitPrice', sortable: false, align: 'end' },
            { text: 'Status', value: 'status', sortable: false, align: 'end' },
            { value: 'actions', sortable: false, align: 'end' },
          ],
          history_headers: [
            { text: 'Valuation Date', value: 'ValuationDate', sortable: false },
            { text: 'Market Value', value: 'MarketValue', sortable: false, align: 'end' },
            { text: 'Unit Price', value: 'UnitPrice', sortable: false, align: 'end' },
          ],
          TextFieldRules: [
            v => !!v || 'field is required',
          ],
          properties: [],
          priceHistory: [],
          selected: [],
          submitted: false,
        }
      },
    
      computed: {
        ...mapGetters([
          "allProperties",
          "allPropertyValues",
          "allApplicationDefaults",
          "currentSystemDate",
          "allRejectionReasons",
          "allUsers",
          "allConfirmationSettings"
        ]),
        currentUser() {
          return this.$store.state.auth.user;
        },
    
        showEditBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 398).map(r => r.AllowEdit)) == 1){
            return true
          }
        }
        return false;
        },
    
        showCreateBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 398).map(r => r.AllowCreate)) == 1){
            return true
          }
        }
        return false;
        },
    
        showConfirmBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 398).map(r => r.AllowConfirm)) == 1){
            return true
          }
        }
        return false;
        },
    
        CheckerID(){
          if(this.allConfirmationSettings.filter(a => a.FunctionID == 316).map(a => a.Status)[0] == false){
            return this.currentUser.SecurityUserID
          } else {
            return 0
          }
        }
      },
    
      created(){
        this.getProperties()
      },
    
      methods: {
        ...mapActions([
          "createPropertyValues",
          "updatePropertyValuesStatus"
        ]),

        getProperties(){
          AdministrationService.getAllPropertiesForUpload()
          .then(res =>{
              this.properties = res.data
          });
        },
    
        async createNew() {
          this.message = '';
          this.loading = true;

          this.currentProperty.MakerID = this.currentUser.SecurityUserID,
          this.currentProperty.CheckerID = this.CheckerID,
          this.currentProperty.LastUserID = this.currentUser.SecurityUserID,
          this.currentProperty.ValuationDate = this.currentSystemDate.DayDate         

          var data = {
            values: [this.currentProperty]
          }

          this.createPropertyValues(data)
            .then(response =>{
              this.$socket.client.emit('socketreq', {
                commit: 'newPropertyValues',
                data: response.data
              });
              this.loading = false;
              this.newDialog = false;
              this.getProperties();
              this.message = response.data.message
            },
            error => {
              this.loading = false;
              this.newDialog = false;
              this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
            })  
        },
    
        updateStatus() {
          this.message = '';
          this.loading = true;
    
          this.selected.forEach(item => {
            item.CheckerID = this.currentUser.SecurityUserID,
            item.LastUserID = this.currentUser.SecurityUserID,
            item.CheckDate = new Date(),
            item.updatedAt = new Date(),
            item.RejectionID = this.RejectionStatus
          });
    
          this.updatePropertyValuesStatus({values: this.selected})
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updProperty',
              data: this.selected
            });
            
            this.message = response.data.message
            this.loading = false;
            this.selected = [];
            this.close()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
            this.selected = [];
            this.close()
          }) 
        },

        getPriceHistory(item){
          this.loading = true;

          AdministrationService.getPropertyPriceHistory({PropertyID: item.PropertyID})
          .then(response => {    
            this.loading = false;       
            this.priceHistory = response.data;
            this.historyDialog = true
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.priceHistory = [];
            this.loading = false;
          }) 
        },
    
        generatePDF(IsPrint) {
          const addFooters = doc => {
            const pageCount = doc.internal.getNumberOfPages()
    
            for (var i = 1; i <= pageCount; i++) {
              doc.setPage(i)
              // text is placed using x, y coordinates
              doc.setFontSize(10).text("Property", 0.5, 0.5);
              // create a line under heading 
              doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
              doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
              doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
                align: 'center'
              })
            }
          }
    
          let doc = new jsPDF({
            orientation: "potrait",
            unit: "in",
            format: "letter"
          });
    
          doc.setFont('helvetica');
          doc.setFontSize(5);
          doc.autoTable({
            body: this.CurrentDataset,
            margin: { left: 0.5, top: 0.6 },
            styles: {overflow: 'linebreak',
                    fontSize: 6},
            showHeader: 'everyPage',
            theme: 'plain'
          });
          addFooters(doc);
          if(IsPrint == true){
            doc.output('dataurlnewwindow');
          } else{
            doc.save('Property.pdf')
          }
        },
    
        NewHolder(item) {
          item.push(
            {
              HolderID: null,
            }
          )
        },
    
        removeHolder(item, parent) {
          const index = parent.findIndex(p => p.HolderID === item.HolderID);
          parent.splice(index, 1)
        },
    
        getFiltered(current){
          this.CurrentDataset = current;
        },
    
        unconfirmed() {
          this.confirmedPropertyValues = false
        },
    
        showEdit () {
          this.edit = true
        },
    
        closeEdit() {
          this.property.def = {},
          this.property.holders = [],
          this.edit = false
        },
    
        showCreate () {
          this.create = true
        },
    
        closeCreate() {
          this.property.def = {},
          this.property.holders = [],
          this.create = false
        },
    
        showMessage(){
          if(this.message){
            return true
          } else {
            return false
          }
        },
    
        validate () {
          this.$refs.form.validate()
        },
    
        reset () {
          this.$refs.form.reset()
        },
    
        close () {
          this.rejectionDialog = false
          this.RejectionStatus = 0
        },
    
        setActiveProperty (item, index) {
          this.currentProperty = item
          this.currentIndex = index
        },
      },
    
      mounted () {
        UserService.isProperties().then(
          () => {
            this.permitted = true;
            this.message = '';
          },
          error => {
            this.permitted = false;
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
        this.$root.$on("unconfirmedPropertyValues", () => {
          this.unconfirmed();
        });
      }
    }
    </script>
    
    <style scoped>
    .list {
      text-align: left;
      max-width: 750px;
      margin: auto;
    }
    
    .v-btn {
      outline: none
    }
    
    .edit {
      background-color: #DBEFFA;
    }
    
    .headline {
      color:white
    }
    </style>
    